/** @jsx jsx */
import { jsx } from '@emotion/core'
import styled from '@emotion/styled'
import React, { useContext, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { getCauseCodeMap, getApiTargetInfo } from 'core/selectors'

import { Button, Icon, Input, Modal, Spin, Tree } from 'antd'

import R from 'ramda'
import './MultiCauseCodeCss.css'
import { getCauseCodeAll } from 'api/pgads'
import { getUnitCodeCauseCodeMapList } from '../core/utils'
import { ErrorContext, SpinContext } from 'context'

const { TreeNode } = Tree
const Circle = styled.div`
  height: 13px;
  width: 13px;
  background-color: orange;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
`

const PurpleCircle = styled.div`
  height: 13px;
  width: 13px;
  background-color: rgb(194, 57, 237, 0.5);
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
`

const createSystemObj = (key, value) =>
  Object.keys(value).length > 0 ? { [key]: value } : {}

const filterUnitCodeInfo = (data, filterText) =>
  R.reduce(
    (obj, system) => ({ ...obj, ...system }),
    {},
    Object.keys(data).map(sys =>
      sys.toLowerCase().includes(filterText)
        ? { [sys]: data[sys] }
        : createSystemObj(sys, filterSystem(data[sys], filterText))
    )
  )

const createCompObj = (key, value) => (value.length > 0 ? { [key]: value } : {})

const filterSystem = (system, filterText) =>
  R.reduce(
    (obj, component) => ({ ...obj, ...component }),
    {},
    Object.keys(system).map(comp =>
      comp.toLowerCase().includes(filterText)
        ? { [comp]: system[comp] }
        : createCompObj(comp, filterComp(system[comp], filterText))
    )
  )

const filterComp = (component, filterText) =>
  component.filter(
    cc =>
      cc.causeCode.toLowerCase().includes(filterText) ||
      cc.description.toLowerCase().includes(filterText)
  )

export const generateCauseCodeKey = cc =>
  `${cc.system}-${cc.component}-${cc.unitCode}-${cc.unitType}-${cc.isOMC}-${cc.causeCode}-${cc.description}`

class CauseCodeTree extends React.Component {
  constructor(props) {
    super(props)
    this.mapCauseCodeKeys = []
  }

  state = {
    selectedKeys: this.props.selectedKeys || this.props.defaultExpandedKeys,
    filterCauseCode: '',
    expandedKeys: this.props.defaultExpandedKeys || this.props.selectedKeys,
    autoExpandParent: true,
    // unitCodes: this.props.unitCodes,
  }

  componentDidMount() {}

  onFilter = (data, filterCC) =>
    filterCC.length > 0 ? filterUnitCodeInfo(data, filterCC) : data

  onSelect = (selectedKeys, _e) => {
    let selectedValues = selectedKeys
      .map(k => this.mapCauseCodeKeys[k])
      .filter(d => d != null)
    selectedValues = R.flatten(
      selectedValues.map(d => Object.keys(d).map(v => d[v]))
    )
    this.setState({
      selectedKeys, // : [e.node.props.eventKey],
      selectedValues,
      // listData,
    })
    this.props.onSelectData &&
      this.props.onSelectData(selectedKeys, selectedValues)
  }

  getTreeNodeKeys = unitCauseCodeMap => {
    const filterKeys = Object.keys(unitCauseCodeMap || {})
      .sort()
      .map(
        sys =>
          unitCauseCodeMap[sys] &&
          Object.keys(unitCauseCodeMap[sys])
            .sort()
            .map(comp =>
              R.uniqBy(
                c => c.causeCode,
                this.getUniqSortMapData(unitCauseCodeMap, sys, comp)
              )
            )
      )

    return R.flatten(filterKeys)
  }

  getUniqSortMapData = (unitCauseCodeMap, sys, comp) => {
    try {
      const data =
        unitCauseCodeMap &&
        unitCauseCodeMap[sys] &&
        unitCauseCodeMap[sys][comp] &&
        unitCauseCodeMap[sys][comp]
          .sort((a, b) => a.causeCode - b.causeCode)
          .map(cc => {
            // const cctitle = `${cc.unitCode}-${cc.causeCode} - ${cc.description}`
            // let ccKey =cc.causeCode + '-' + cc.system
            // const ccKey = `${cc.system}-${cc.component}-${cc.unitCode}-${cc.unitType}-${cc.isOMC}-${cc.causeCode}-${cc.description}`
            const ccKey = generateCauseCodeKey(cc)
            return ccKey
          })

      return data
    } catch (err) {
      return []
    }
  }

  getTreeNodeUniqSort = (unitCauseCodeMap, sys, comp) => {
    try {
      const data =
        unitCauseCodeMap &&
        unitCauseCodeMap[sys] &&
        unitCauseCodeMap[sys][comp] &&
        unitCauseCodeMap[sys][comp]
          .sort((a, b) => a.causeCode - b.causeCode)
          .map(cc => {
            // const cctitle = `${cc.unitCode}-${cc.causeCode} - ${cc.description}`
            // let ccKey =cc.causeCode + '-' + cc.system
            // const ccKey = `${cc.system}-${cc.component}-${cc.unitCode}-${cc.unitType}-${cc.isOMC}-${cc.causeCode}-${cc.description}`
            const ccKey = generateCauseCodeKey(cc)
            // if (this.mapCauseCodeKeys[ccKey] === undefined) {
            this.mapCauseCodeKeys[ccKey] = {
              ...this.mapCauseCodeKeys[ccKey],
              [cc.unitCode]: cc,
            }
            // this.mapCauseCodeKeys[ccKey].add(cc.unitCode)
            // }
            return cc
          })

      return data
    } catch (err) {
      return []
    }
  }

  getTreeNode = (causeCodeMap, filterCauseCode) => {
    const unitCauseCodeMap = filterCauseCode || causeCodeMap

    return Object.keys(unitCauseCodeMap || {})
      .sort()
      .map(sys => (
        <TreeNode selectable={false} title={sys} key={sys}>
          {unitCauseCodeMap[sys] &&
            Object.keys(unitCauseCodeMap[sys])
              .sort()
              .map(comp => (
                <TreeNode
                  selectable={false}
                  title={comp}
                  key={`${sys}-${comp}`}
                >
                  {R.uniqBy(
                    c => c.causeCode,
                    this.getTreeNodeUniqSort(unitCauseCodeMap, sys, comp)
                  ).map(cc => (
                    <TreeNode
                      title={`${cc.causeCode} - ${cc.description}`}
                      // icon={cc.isOMC ? <Icon type="logout" /> : <Icon type="file" />}
                      key={`${cc.system}-${cc.component}-${cc.unitCode}-${cc.unitType}-${cc.isOMC}-${cc.causeCode}-${cc.description}`}
                      omc={cc.isOMC}
                      icon={() =>
                        cc.isOMC ? (
                          // <Icon type="logout" style={{ backgroundColor: 'orange' }} />
                          <Circle />
                        ) : cc.causeCode >= 9180 && cc.causeCode <= 9199 ? (
                          <PurpleCircle />
                        ) : (
                          <Icon type="file" />
                        )
                      }
                      isLeaf
                    />
                  ))}
                </TreeNode>
              ))}
        </TreeNode>
      ))
  }

  render() {
    let id = null
    const { unitCodes } = this.props
    // const { unitCodeCauseCodeMap = {} } = this.state
    const unitCodeCauseCodeMap = getUnitCodeCauseCodeMapList(
      this.props.causeCodeList
    )
    let data = {}
    if (unitCodes.length === 1) {
      data = unitCodeCauseCodeMap[unitCodes[0]] || {}
    } else {
      const vd = Object.keys(unitCodeCauseCodeMap).filter(uc =>
        unitCodes.length === 0
          ? true
          : unitCodes.length > 1
          ? unitCodes.includes(uc)
          : false
      )

      if (vd.length === 1) {
        data = unitCodeCauseCodeMap[vd[0]] || {}
      } else if (vd.length > 0) {
        const dd = vd.reduce((k, k1) =>
          R.mergeDeepWith(
            R.compose(
              R.sort((a, b) => a.causeCode - b.causeCode),
              R.concat
            ),
            typeof k === 'string' ? unitCodeCauseCodeMap[k] : k,
            unitCodeCauseCodeMap[k1]
          )
        )
        data = dd
      }
    }

    const treeTags = this.getTreeNode(data, this.state.filterCauseCodeList)

    return [
      <div
        key="caucecode-div"
        style={{ display: 'grid', gridTemplateColumns: 'max-content 2% auto' }}
      >
        <Button
          onClick={() =>
            this.setState({
              expandedKeys: [],
              autoExpandParent: false,
            })
          }
          type="dashed"
        >
          Collapse All
        </Button>
        <div />
        <Input
          style={{ order: 1, marginBottom: '10px' }}
          // size="small"
          icon="search"
          key="filterCauseCode"
          placeholder="Filter"
          name="filterCauseCode"
          defaultValue={this.state.filterCauseCode || ''}
          onKeyUp={e => {
            e.persist()
            if (id) {
              clearTimeout(id)
            }
            id = setTimeout(() => {
              const lowerCaseSearch = e.target.value.toLowerCase()
              const filterCauseCodeList = this.onFilter(data, lowerCaseSearch)
              const expandedKeys = this.getTreeNodeKeys(
                this.state.filterCauseCodeList || {}
              )
              this.setState({
                filterCauseCode: e.target.value,
                filterCauseCodeList,
                autoExpandParent: true,
                // expandedKeys:  expandedKeys == undefined || expandedKeys.length == 0 ? [] : expandedKeys,
                // expandedKeys,
              })
              this.setState({ expandedKeys })
            }, 200)
          }}
          allowClear={false}
        />
      </div>,

      <Tree
        key="causeCode"
        defaultSelectedKeys={
          this.props.selectable ? this.props.defaultExpandedKeys : []
        }
        defaultExpandedKeys={this.props.defaultExpandedKeys}
        defaultCheckedKeys={this.props.defaultExpandedKeys}
        onSelect={this.onSelect}
        selectedKeys={this.state.selectedKeys}
        selectable={this.props.selectable || false}
        onCheck={this.onSelect}
        // multiple={this.props.multiple || false}
        checkable={this.props.checkable || false}
        style={{
          height: this.props.height || 'calc(70vh)',
          overflow: 'auto',
          order: 2,
        }}
        defaultExpandAll={false}
        expandedKeys={this.state.expandedKeys}
        autoExpandParent={this.state.autoExpandParent}
        onExpand={(expandedKeys, { expanded }) => {
          // this.setState({ expandedKeys })
          // this.state.expandedKeys
          if (expanded)
            this.setState({
              expandedKeys: [
                ...(this.state.expandedKeys || []),
                ...expandedKeys,
              ],
            })
          else
            this.setState({
              // expandedKeys: this.state.expandedKeys.filter(k => !expandedKeys.includes(k)),
              expandedKeys,
            })
          this.setState({ autoExpandParent: false })
        }}
        showIcon
        // switcherIcon={<Icon type="down" />}
        className="hide-file-icon"
        showLine
      >
        {treeTags}
      </Tree>,
    ]
  }
}

const PromptModal = props => {
  const [causeCodeList, setCauseCodeList] = useState(props.causeCodeList || [])
  const { setSpinning, spinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)
  useEffect(
    _ => {
      if (!props.causeCodeList) {
        setSpinning(true)
        getCauseCodeAll(props.apiTargetInfo).fork(setError, list => {
          setSpinning(false)
          setCauseCodeList(list)
        })
      }
    },
    [props.apiTargetInfo, props.causeCodeList, setError, setSpinning]
  )
  // const unitCodeCauseCodeMap = useMemo(
  //   _ => getUnitCodeCauseCodeMapList(causeCodeList),
  //   [causeCodeList]
  // )

  const valObj = causeCodeList.filter(
    l =>
      (props.causeCodeValue || []).includes(l.causeCode) &&
      (props.unitCodes || []).includes(l.unitCode)
  )
  const valKey = valObj.map(v => generateCauseCodeKey(v))
  const [selectedKeys, setSelectedKeys] = useState(
    props.selectedKeys || props.defaultExpandedKeys || valKey || []
  )
  const [selectedValues, setSelectedValues] = useState(
    props.selectedValues || valObj || []
  )
  return (
    <Modal
      title="Cause Code"
      //      closable={false}
      visible={props.visibleDialog}
      size="large"
      onDialogClose={() => props.onCancelAction(props.defaultExpandedKeys)}
      footer={
        <div>
          <Button
            color="red"
            onClick={() => {
              // this.setState({
              //   selectedKeys: this.props.defaultExpandedKeys,
              // })
              props.onCancelAction(props.defaultExpandedKeys)
            }}
          >
            Cancel
          </Button>
          <Button
            color="green"
            onClick={() => props.onDialogClose(selectedKeys, selectedValues)}
            type="primary"
          >
            OK
          </Button>
        </div>
      }
      onCancel={() => props.onCancelAction(props.defaultExpandedKeys)}
      // onClose={e => this.props.onCancelAction(this.props.defaultExpandedKeys)}
      style={{ top: 20 }}
      width="50%"
    >
      <Spin spinning={spinning}>
        <CauseCodeTree
          {...props}
          onSelectData={(keys, vals) => {
            setSelectedValues(vals)
            setSelectedKeys(keys)
          }}
          selectedKeys={props.selectedKeys || selectedKeys}
          selectedValues={props.selectedValues || selectedValues}
          causeCodeList={causeCodeList}
        />
      </Spin>
    </Modal>
  )
}

const mapStateToProps = state => ({
  causeCode: getCauseCodeMap(state),

  apiTargetInfo: getApiTargetInfo(state),
})

export const CauseCodeTreeData = connect(mapStateToProps)(CauseCodeTree)

export default connect(mapStateToProps)(PromptModal)
